/**
 * The OAuth callback redirects to `/settings` or `/welcome` with a result code
 * in the query string. Both pages report it in these words.
 *
 * Shared rather than duplicated because a planner told "Gmail connected" on
 * one page and something subtly different on the other learns to distrust
 * both. Which page they land on is decided by the `return_to` stored on the
 * state nonce — see `backend/src/routes/gmail.ts`.
 */
export const CALLBACK_MESSAGES: Record<string, { ok: boolean; text: string }> = {
  connected: {
    ok: true,
    // Deliberately does not promise a scan. captureWatermark() reads no mail:
    // it records where Gmail's history feed stands now and tracks forward from
    // there. Saying otherwise sets the planner waiting for threads that will
    // never appear.
    text: 'Gmail connected. Replies to your inquiries will be tracked.',
  },
  denied: { ok: false, text: 'You declined the Google permission request.' },
  expired: { ok: false, text: 'That connection attempt timed out. Try again.' },
  invalid: { ok: false, text: 'Google sent back an incomplete response. Try again.' },
  failed: { ok: false, text: 'Connecting failed. Check the server logs for details.' },
  no_refresh_token: {
    ok: false,
    text: 'Google did not issue a refresh token. Remove VendorOps at myaccount.google.com/permissions, then reconnect.',
  },
};
